import { createFileRoute } from '@tanstack/react-router';
import { ExternalDisplayRoot } from 'containers/ExternalDisplay/ExternalDisplayFeature';

export const Route = createFileRoute('/display/')({
  component: ExternalDisplayRoot,
});
